import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa'; // Default user icon
import icon from '../../assets/img/logo_trans.png';

const AppNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const accessToken = localStorage.getItem('access_token');
    const username = localStorage.getItem('username');

    if (accessToken && username) {
      setUser({ isLoggedIn: true, name: username });
    } else {
      setUser({ isLoggedIn: false });
    }
  }, []);

  if (location.pathname === '/' || location.pathname === '/data-privacy') {
    return null;
  }

  const UserNavbar = () => {
    const [activeTab, setActiveTab] = useState(location.pathname);

    useEffect(() => {
      setActiveTab(location.pathname);
    }, [location]);

    const handleSelect = (eventKey) => {
      setActiveTab(eventKey);
    };

    const handleBrandClick = () => {
      if (location.pathname === '/login') {
        navigate('/');
      } else {
        navigate('/aktivity');
      }
    };

    const handleLogout = () => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('username');
      setUser({ isLoggedIn: false });
      navigate('/login');
    };

    return (
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand onClick={handleBrandClick} style={{ cursor: 'pointer' }} className="d-flex align-items-center">
            <img
              src={icon}
              alt="Logo"
              className="d-inline-block align-top"
              style={{ maxHeight: '50px', width: 'auto' }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto" activeKey={activeTab} onSelect={handleSelect}>
              <Nav.Link as={Link} to="/aktivity" eventKey="/aktivity" className={activeTab === '/aktivity' ? 'active-tab' : ''}>Nová aktivita</Nav.Link>
              <Nav.Link as={Link} to="/historia" eventKey="/historia" className={activeTab === '/historia' ? 'active-tab' : ''}>História</Nav.Link>
              <Nav.Link as={Link} to="/vzory-vystupu" eventKey="/vzory-vystupu" className={activeTab === '/vzory-vystupu' ? 'active-tab' : ''}>Vzory výstupu</Nav.Link>
              <Nav.Link as={Link} to="/spotreba" eventKey="/spotreba" className={activeTab === '/spotreba' ? 'active-tab' : ''}>Spotreba</Nav.Link>
            </Nav>

            {/* User Profile Section */}
            {user?.isLoggedIn && (
              <Nav className="ms-auto d-flex align-items-center">
                <Dropdown align="end">
                  <Dropdown.Toggle variant="link" id="dropdown-user" className="d-flex align-items-center text-decoration-none">
                    <span className="me-2">{user.name}</span>
                    <FaUserCircle size={40} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={handleLogout}>Odhlásiť</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };

  return <UserNavbar />;
};

export default AppNavbar;
